import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { CellData, ComponentData, DataMap } from '@ddt-web/data-service';
import { distinctUntilChangedDeep } from '@ddt-web/generic-utils';
import { ApplicationStateStoreProxyService, PerformanceState } from '@ddt-web/shared-stores';
import * as flatten from 'lodash/flatten';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationConstants } from '../../config';
import { MiniCompareDataPointsConfig, miniCompareTableData, MiniCompareTableDataConfig, miniCompareTableDataPointsList, miniCompareTableGrossDataPoints, ModelDropdown } from '../../models';
import { ModelsBrowseDataService } from '../../services';

@Component({
	selector: 'mb-mini-compare-data-table',
	templateUrl: './mini-compare-data-table.component.html',
	styleUrls: ['./mini-compare-data-table.component.scss']
})
export class MiniCompareDataTableComponent implements OnChanges {
	@InjectConfig(ModelsExperienceConfigKey.ENABLE_ADD_TO_COMPARE_MODEL) public readonly enableAddToCompareModel: boolean = false;
	@InjectConfig(ModelsExperienceConfigKey.MINI_COMPARE_TABLE_DATA_POINTS_LIST) public readonly compareDataList: MiniCompareDataPointsConfig = miniCompareTableDataPointsList;
	@InjectConfig(ModelsExperienceConfigKey.MINI_COMPARE_TABLE_GROSS_DATA_POINTS) public readonly grossCompareDataList: MiniCompareDataPointsConfig = miniCompareTableGrossDataPoints;

	@Input() public data: ComponentData;
	@Input() public selectedPortfolios: ModelDropdown[];
	@Input() public showOptionalData: boolean;
	public compareDataConfig: MiniCompareTableDataConfig = miniCompareTableData;
	public ApplicationConstants: ApplicationConstants = ApplicationConstants;
	public compareData: Array<DataMap<CellData>> = [];
	public customAdvisoryFee$: Observable<number>;
	@ViewChild('benchmarkDisclosure') public benchmarkDisclosureRef: ElementRef;

	constructor(
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService,
		private modelsBrowseDataService: ModelsBrowseDataService
	) { }

	public ngOnChanges(): void {
		this.customAdvisoryFee$ = this.applicationStateStoreProxyService.getPerformanceState()
			.pipe(
				distinctUntilChangedDeep(),
				map((state: PerformanceState) => state?.customAdvisoryFee)
			);

		if (this.data.success) {
			const miniCompareData = flatten(this.data.getTabById('mini.compare.data')?.tableData?.map(tableData => tableData['rows'])) || [];
			this.compareData = [];
			this.selectedPortfolios.forEach(portfolio => {
				this.compareData.push(miniCompareData.find(model => model.id?.formattedValue === portfolio.modelId) || []);
			});
		}
	}

	public scrollToBenchmarkDisclosure(index): void {
		const element = this.benchmarkDisclosureRef.nativeElement.querySelector(`#performance-benchmark-disclosure-${index}`);
		element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	}

	public modelBenchmarkDisclaimer$(modelId: CellData): Observable<string | undefined> {
		const familyId = this.selectedPortfolios.find(model => model.modelId === modelId?.rawValue)?.familyId;
		return this.modelsBrowseDataService.getBenchmarkDisclaimer(familyId);
	}
}
